// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"54f0ac5a","407":"70e2c0a0","581":"70e2c0a0"}[chunkId] + ".chunk.css";
};